import {observable} from 'mobx';
import {Language} from './language';
import {OfferProduct} from './offer-product';
import {OfferProductLocaleKey} from './offer-product-locale-key';
import {construct, createInstance, ModelProperties} from '../utils';

export class OfferProductLocaleContent {
    @observable id!: number;

    @observable contentEdited!: string;

    @observable contentVerified!: string;

    @observable verified!: boolean;

    @observable productId!: number;

    @observable keyId!: number;

    @observable languageId!: number;

    @observable product?: OfferProduct;

    @observable key?: OfferProductLocaleKey;

    @observable language?: Language;

    constructor(content?: ModelProperties<OfferProductLocaleContent>) {
        if (content) {
            construct(this, content);
            this.key = createInstance(OfferProductLocaleKey, content.key);
            this.product = createInstance(OfferProduct, content.product);
            this.language = createInstance(Language, content.language);
        }
    }
}
